import { render, staticRenderFns } from "./ActivityAdd.vue?vue&type=template&id=38bf2beb"
import script from "./ActivityAdd.vue?vue&type=script&lang=js"
export * from "./ActivityAdd.vue?vue&type=script&lang=js"
import style0 from "./ActivityAdd.vue?vue&type=style&index=0&id=38bf2beb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports